module.exports = __webpack_public_path__ + "img/pr-9.7ced77ef.png";